export function thousandsSeparator(num) {
	return parseInt(num, 10).toLocaleString('en-US', { minimumFractionDigits: 0 });
}
